export default "__VITE_ASSET__c2f9627a__"